import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { BarChart3, Settings, ArrowRight, Upload } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { isInDevMode } from "@/config/featureFlags";
import { useUserRole } from "@/hooks/useUserRole";

export const AdminPanelNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAdmin, loading } = useUserRole();

  // Only show in development environments when dev mode is enabled
  const isDev = import.meta.env.DEV || 
    window.location.hostname.includes('lovable') || 
    localStorage.getItem('forceDevControls') === 'true';
    
  const shouldShow = isDev && !loading && isInDevMode();
  
  if (!shouldShow) return null;

  const handleNavigateToAnalytics = () => {
    console.log("=== NAVIGATING TO ANALYTICS ===");
    try {
      navigate('/analytics');
    } catch (error) {
      console.error("Navigation error:", error);
      window.location.href = window.location.origin + '/analytics';
    }
  };

  const handleNavigateToAdmin = () => {
    console.log("=== NAVIGATING TO ADMIN ===");
    try {
      navigate('/admin');
    } catch (error) {
      console.error("Navigation error:", error);
      window.location.href = window.location.origin + '/admin';
    }
  };

  const handleNavigateToImport = () => {
    console.log("=== NAVIGATING TO IMPORT ===");
    try {
      navigate('/import');
    } catch (error) {
      console.error("Navigation error:", error);
      window.location.href = window.location.origin + '/import';
    }
  };

  const isOnAdminRoute = location.pathname === '/admin' || location.pathname === '/analytics' || location.pathname === '/import';

  return (
    <div className="fixed bottom-4 right-4 z-50">
      {isOnAdminRoute ? (
        // Show navigation between admin pages when on admin routes
        <Card className="bg-blue-600 border-blue-500 shadow-lg">
          <CardContent className="p-3">
            <div className="flex gap-2">
              <Button
                onClick={handleNavigateToAnalytics}
                variant={location.pathname === '/analytics' ? "secondary" : "ghost"}
                className={location.pathname === '/analytics' 
                  ? "bg-white/20 text-white hover:bg-white/30" 
                  : "text-white hover:bg-white/20"
                }
                size="sm"
              >
                <BarChart3 className="w-4 h-4 mr-2" />
                Analytics
              </Button>
              <Button
                onClick={handleNavigateToAdmin}
                variant={location.pathname === '/admin' ? "secondary" : "ghost"}
                className={location.pathname === '/admin' 
                  ? "bg-white/20 text-white hover:bg-white/30" 
                  : "text-white hover:bg-white/20"
                }
                size="sm"
              >
                <Settings className="w-4 h-4 mr-2" />
                Admin
              </Button>
              <Button
                onClick={handleNavigateToImport}
                variant={location.pathname === '/import' ? "secondary" : "ghost"}
                className={location.pathname === '/import' 
                  ? "bg-white/20 text-white hover:bg-white/30" 
                  : "text-white hover:bg-white/20"
                }
                size="sm"
              >
                <Upload className="w-4 h-4 mr-2" />
                Import
              </Button>
            </div>
          </CardContent>
        </Card>
      ) : (
        // Show main admin panel access button when not on admin routes
        <Button
          onClick={handleNavigateToImport}
          className="bg-blue-600 hover:bg-blue-700 text-white shadow-lg border-blue-300"
          size="lg"
        >
          <Settings className="w-5 h-5 mr-2" />
          Admin Panel [DEV]
          <ArrowRight className="w-4 h-4 ml-2" />
        </Button>
      )}
    </div>
  );
};